<div
  class="rotation-warning-overlay"
  *ngIf="deviceService.showWarning$ | async"
>
  <div class="rotation-content">
    <i class="fas fa-rotate fa-3x mb-3"></i>
    <h3>{{ "rotateDevice" | translate }}</h3>
    <p>{{ "rotateMessage" | translate }}</p>
  </div>
</div>
